import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";

// Pages
import HomePage from "./pages/HomePage";
import AboutPage from "./pages/AboutPage";
import ServicesPage from "./pages/ServicesPage";
import SchoolPage from "./pages/SchoolPage";
import CoursePage from "./pages/CoursePage";
import BlogPage from "./pages/BlogPage";
import BlogPostPage from "./pages/BlogPostPage";
import ContactPage from "./pages/ContactPage";
import DashboardPage from "./pages/DashboardPage";
import LoginPage from "./pages/LoginPage";
import RegisterPage from "./pages/RegisterPage";
import ForgotPasswordPage from "./pages/ForgotPasswordPage";
import ResetPasswordPage from "./pages/ResetPasswordPage";
import PaymentSuccessPage from "./pages/PaymentSuccessPage";
import PaymentCancelledPage from "./pages/PaymentCancelledPage";
import EbookPage from "./pages/EbookPage";
import EbookStorePage from "./pages/EbookStorePage";
import FreeResourcesPage from "./pages/FreeResourcesPage";
import AdminPage from "./pages/AdminPage";
import EbookViewerPage from "./pages/EbookViewerPage";
import PromoPage from "./pages/PromoPage";
import FreeTrainingPage from "./pages/FreeTrainingPage";
import WorkbookPage from "./pages/WorkbookPage";
import NotaryPage from "./pages/NotaryPage";

// Layout
import Layout from "./components/Layout";

import "./App.css";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-right" richColors />
        <Routes>
          {/* Promo page without navigation */}
          <Route path="/promo" element={<PromoPage />} />
          <Route path="/sale" element={<PromoPage />} />
          <Route path="/training" element={<FreeTrainingPage />} />
          <Route path="/free-training" element={<FreeTrainingPage />} />
          
          <Route element={<Layout />}>
            <Route path="/" element={<HomePage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/services" element={<ServicesPage />} />
            <Route path="/school" element={<SchoolPage />} />
            <Route path="/business-school" element={<SchoolPage />} />
            <Route path="/school/course/:courseId" element={<CoursePage />} />
            <Route path="/blog" element={<BlogPage />} />
            <Route path="/blog/:postId" element={<BlogPostPage />} />
            <Route path="/contact" element={<ContactPage />} />
            <Route path="/ebook" element={<EbookPage />} />
            <Route path="/ebooks" element={<EbookStorePage />} />
            <Route path="/free-resources" element={<FreeResourcesPage />} />
            <Route path="/admin" element={<AdminPage />} />
            <Route path="/ebook/view/:ebookId" element={<EbookViewerPage />} />
            <Route path="/workbook" element={<WorkbookPage />} />
            <Route path="/financial-clarity-workbook" element={<WorkbookPage />} />
            <Route path="/notary" element={<NotaryPage />} />
            <Route path="/dashboard" element={<DashboardPage />} />
            <Route path="/login" element={<LoginPage />} />
            <Route path="/register" element={<RegisterPage />} />
            <Route path="/forgot-password" element={<ForgotPasswordPage />} />
            <Route path="/reset-password" element={<ResetPasswordPage />} />
            <Route path="/payment-success" element={<PaymentSuccessPage />} />
            <Route path="/payment-cancelled" element={<PaymentCancelledPage />} />
          </Route>
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
